<template>
  <form id="mortgage-calculator-form" class="form mortgage-calculator-form floating-label container" v-on:submit.prevent="submitForm">
    <div :class="formInitial || recalculate ? 'mortgage-calculator-form-single-column mt-md-5' : 'mortgage-calculator-form-multi-column'">
      <div :class="formInitial || recalculate ? 'row' : 'row pt-md-5'">
        <div :class="formInitial || recalculate ? 'col-sm-12 col-md-12' : 'pr-md-5 pr-lg-5 col-sm-12 col-lg-6 w-print-lg'">
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <!-- Price Input Field -->
            <div :class="formInitial || recalculate ? 'col-lg-6 col-md-8 col-sm-12' : 'col-md-12 col-sm-12'">
              <div class="form-group mb-md-4">
                <div :class="homePriceModel !== '' ? 'floating-label is-floating' : 'floating-label'">
                  <label for="homeprice-field">Home Price or Value</label>
                  <masked-input ref="homeprice"
                         id="homeprice-field"
                         placeholder=""
                         name="homeprice-field"
                         autocapitalize="off"
                         autocomplete="off"
                         spellcheck="false"
                         aria-label="Home Price or Value"
                         class="form-control homeprice-input"
                         @blur="toggleLabel($event, 'homePrice')"
                         @focus="toggleLabel($event)"
                         v-model="homePriceModel"
                         type="text"
                         :mask="currencyMask"
                         @input="handleDPAmountUpdate($event)"/>
                  <div class="mortgage-rate-calculator-form__error-message" v-show="formSubmitted && !isMinimumValue && !loading && homePriceModel">Please enter an amount greater than the down payment.</div>
                  <div class="mortgage-rate-calculator-form__error-message" v-show="formSubmitted && !initialHomePriceState && !isMinimumValue && !loading && !homePriceModel">Please enter an amount.</div>
                </div>
              </div>
            </div>
          </div>
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <!-- down payment field -->
            <div :class="formInitial || recalculate ? 'col-lg-4 col-md-5 col-sm-12' : 'col-md-8 col-sm-12'">
              <div class="form-group mb-md-4">
                <div :class="downPaymentAmountModel ? 'floating-label is-floating' : 'floating-label'">
                  <label for="down-payment-field">Down Payment</label>
                  <masked-input id="down-payment-field"
                         placeholder=""
                         name="down-payment-field"
                         autocapitalize="off"
                         autocomplete="off"
                         spellcheck="false"
                         aria-label="Down Payment"
                         class="form-control down-payment-input"
                         type="text"
                         @blur="toggleLabel($event, 'downPayment')"
                         @focus="toggleLabel($event)"
                         v-model="downPaymentAmountModel"
                         :mask="currencyMask"
                         @input="handleDPAmountUpdate($event)" />
                </div>
                <div class="mortgage-rate-calculator-form__error-message" v-show="formSubmitted && !loading && !downPaymentAmountModel">Please enter an amount.</div>
                <div class="mortgage-rate-calculator-form__error-message" v-show="formSubmitted && !loading && downPaymentAmountModel && !isMinimumValue">Please enter a value lower than the Home Price.</div>
                <!--<div class="mortgage-rate-calculator-form__error-message" v-show="errored && formSended && !initialAmountModel && !loading &&  initialAmountModel == ''">INITIAL AMOUNT IS REQUIRED</div>-->
                <!-- div class="mortgage-rate-calculator-form__error-message" v-show="!errored && formSended && !downPaymentAmountModel && !loading">This field is required.</div-->
              </div>
            </div>
            <!-- down payment percentage -->
            <div :class="formInitial || recalculate ? 'col-lg-2 col-md-3 col-sm-12' : 'col-md-4 col-sm-12'">
              <div class="form-group mb-md-4">
                <div :class="paymentPercentageModel.length >= 1 ? 'floating-label is-floating' : 'floating-label'">
                  <label for="payment-percentage-field">Percentage</label>
                  <input id="payment-percentage-field"
                         placeholder=""
                         name="payment-percentage-field"
                         autocapitalize="off"
                         autocomplete="off"
                         spellcheck="false"
                         aria-label="LABEL HERE"
                         class="form-control payment-percentage-input"
                         type="text"
                         @blur="toggleLabel($event)"
                         @focus="toggleLabel($event)"
                         @input="HandleDPPercentUpdate($event)"
                         v-model="paymentPercentageModel"
                         disabled/>
                </div>
                <!-- div class="mortgage-rate-calculator-form__error-message" v-show="!errored && formSended && !paymentPercentageModel && !loading">This field is required.</div-->
              </div>
            </div>
          </div>
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <!-- term length -->
            <div :class="formInitial || recalculate ? 'col-lg-4 col-md-5 col-sm-12' : 'col-md-8 col-sm-12'">
              <div class="form-group mb-md-4">
                <div>
                  <select id="length-field" class="form-control term-length-list" aria-label="term length" v-model="termModel">
                    <!--Added default term lengths for now so its not empty while it does a call to get the term lengths-->
                    <option value="default">Loan Term</option>
                    <option name="15 years" value="15">15 years</option>
                    <option name="30 years" value="30">30 years</option>
                  </select>
                  <div class="mortgage-rate-calculator-form__error-message" v-show="formSubmitted && termModel==='default' && !termModelValid && !loading">Please select a value.</div>
                </div>
              </div>
            </div>
            <div :class="formInitial || recalculate ? 'col-lg-2 col-md-3 col-sm-12' : 'col-md-4 col-sm-12'">
              <div class="form-group mb-md-4">
                <div :class="interestRateModel ? 'floating-label is-floating' : 'floating-label'">
                  <label for="interest-rate-field">Interest Rate</label>
                  <masked-input id="interest-rate-field"
                         placeholder=""
                         name="interest-rate-field"
                         autocapitalize="off"
                         autocomplete="off"
                         spellcheck="false"
                         class="form-control interest-rate-input"
                         type="text"
                         @blur="toggleLabel($event)"
                         @focus="toggleLabel($event)"
                         v-model="interestRateModel"
                         :mask="percentageMask" />
                </div>
                <!--<div class="mortgage-rate-calculator-form__error-message" v-show="errored && formSended && !initialAmountModel && !loading &&  initialAmountModel == ''">INITIAL AMOUNT IS REQUIRED</div>-->
                <div class="mortgage-rate-calculator-form__error-message" v-show="formSubmitted && (!interestRateModel || interestRateModel == '%' || interestRateModel === '0%') && !interestRateMin && !loading">Please enter a value greater than 0.</div>
              </div>
            </div>
          </div>
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <div :class="formInitial || recalculate ? 'col-md-6 col-sm-12' : 'col-md-12 col-sm-12'">
              <div :class="formInitial || recalculate ? 'form-group d-flex justify-content-center' : 'form-group d-flex justify-content-center justify-content-md-start'">
                <button :class="formInitial || recalculate ? 'btn btn-primary btn-wide btn-pill btn-mortgage-submit' : 'btn btn-primary btn-wide btn-pill btn-mortgage-recalc'"
                        type="submit">
                  <span class="mortgage-rate-label" v-if="!loading">{{ formInitial ? "Calculate" : "Re-calculate" }}</span>
                  <div class="mortgage-rate-calculator-form__loading" v-else>
                    <div class="mortgage-rate-calculator-form__spinner"></div>
                    Loading...
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!formInitial && loadedPercentage" class="col-sm-12 col-lg-6 w-print-lg">
          <div v-if="loadedPercentage" class="row mortgage-rate-calculator-form__percent my-md-3">
            <div class="col-md-12 d-flex justify-content-center align-items-center">

              <h2 class="fs-5 mortgage-rate-calculator-form__percent-calc">
                <span>$</span>
                <AnimatedNumber :value="monthlyPayment" :duration="1000" :formatValue="formatToPrice" />
              </h2>
              <div class="mortgage-rate-calculator-form__percentInfo">
                <div class="mortgage-rate-calculator-form__percentInfo-sign">*</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!formInitial" :class="!formInitial && !recalculate ? 'row mortgage-disclaimer-container' : 'row mortgage-disclaimer-container justify-content-center'">
        <div :class="!formInitial && !recalculate ? 'col-md-12 col-sm-12' : 'col-md-6 col-sm-12'">
          <hr v-show="!formInitial" :class="!formInitial && !recalculate ? 'mortgage-rate-calculator-form__separator' : 'mortgage-rate-calculator-form__separator'" />
        </div>
      </div>
      <div v-show="!formInitial" :class="!formInitial && !recalculate ? 'row mortgage-disclaimer-container' : 'row mortgage-disclaimer-container justify-content-center'">
        <div :class="!formInitial && !recalculate ? 'col-md-12 col-sm-12' : 'col-md-12 col-sm-12'">
          <div v-html="disclaimer"></div>
        </div>
      </div>
      <div :class="formInitial || recalculate ? 'row' : 'row pt-md-5'">
      </div>
    </div>
  </form>
</template>

<script>
  import axios from "axios"
  import AnimatedNumber from "../../../components/AnimatedNumber.vue"
  import MaskedInput from "../../../utils/MaskedInput.js"
  import { currencyMask, percentageMask } from '../../../utils/input-mask';

  export default {
    data() {
      return {
        principal: '',
        rate: '',
        months: '',
        monthlyPayment: 0,
        errored: false,
        index: 0,
        loading: false,
        showDefault: false,
        loaded: false,
        radius: 5,
        paymentPercentageModel: "",
        initialAmountModel: "",
        homePriceModel: "",
        downPaymentAmountModel: "",
        interestRateModel: "",
        termModel: "default",
        termModelValid: true,
        formSended: false,
        formInitial: true,
        apyvalue: 0.0,
        loadedPercentage: true,
        recalculate: false,
        termLength: "",
        axiosAbortController: new AbortController(), // <-- updated here
        isMinimumValue: true,
        interestRateMin: true,
        downPaymentMax: true,
        initialDownPaymentState: true,
        initialHomePriceState: true,
        currencyMask,
        percentageMask,
        formSubmitted : false
      }
    },
    components: {
      AnimatedNumber,
      MaskedInput
    },
    computed: {
      isMobile() {
        return this.$mq != "desktop"
      },
      isIOSorAndroid() {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) || /(android)/i.test(navigator.userAgent)) {
          return true;
        } else {
          return navigator.maxTouchPoints &&
            navigator.maxTouchPoints > 2 &&
            /MacIntel/.test(navigator.platform);
        }
      },
      /*google: gmapApi,*/
      isDisabled() {
        let amount = this.convertStringToNumber()
        let condition = Boolean(amount) && this.downPaymentAmountModel && this.isMinimumValue && this.termModel && (this.termModel !== "default") && this.interestRateModel && (this.interestRateModel != "%") && this.interestRateMin
        if (condition) {
          return false
        } else {
          return true
        }
      }
    },
    methods: {
      printWindow: function () {
        window.print()
      },
      convertStringToNumber(model = this.homePriceModel) {
        if (!model && model !== 0) return '';
        
        const modelStr = typeof model === 'string' ? model : String(model);
        
        let amount = modelStr.replace("%", "").replace("$", "").replace(/,/g, '');
        return amount;
      },
      /**
       * Converts a string representation of a value with percentage symbol to a numerical percentage value.
       * If the input string has a length of 3 or more characters, the function recognizes it as a decimal value
       * and divides the cleaned-up value by 100 to convert it to a numerical percentage.
       * @param {string} model - The string value to be converted.
       * @returns {number} The numerical percentage value after conversion.
       */
      convertStringToPercentage(model) {
        if (!model && model !== 0) return '';    
        const modelStr = typeof model === 'string' ? model : String(model);
        
        let amount = modelStr.replace("%", "").replace("$", "").replace(/,/g, '');
        return amount;
      },
      onlyNumber($event) {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
          // 46 is dot
          $event.preventDefault()
        }
      },
      formatToPrice(value) {
        const num = Number(value)
        return isNaN(num) ? '0.00' : `${num.toFixed(2)}`
      },
      minimumRule(model = "homePriceModel", $event) {
        let amount = Number(this.convertStringToNumber(this.homePriceModel));
        let amountDownPayment = Number(this.convertStringToNumber(this.downPaymentAmountModel));

        switch (model) {
          case "interestRateModel":
            this.interestRateMin = this.isMinModelValue(this.interestRateModel, 0)
            break
          case "termModel":
            if (this.termModel != 'default') this.termModelValid = true
            else this.termModelValid = false
            break
          case "downPaymentAmountModel":
            if (amount < amountDownPayment) this.downPaymentMax = false
            else this.downPaymentMax = true

            if (amount >= 0 && amount > amountDownPayment) {
              this.isMinimumValue = true
              this.loadedPercentage = true
            }
            else {
              this.loadedPercentage = false
              this.isMinimumValue = false
            }
            if (this.downPaymentAmountModel && this.paymentPercentageModel && $event) {
              this.handleDPAmountUpdate($event)
            }
            else if (!this.downPaymentAmountModel) {
              this.paymentPercentageModel = '';
            }
            break
          default:
            if (amount >= 0 && amount > amountDownPayment) {
              this.isMinimumValue = true
              this.loadedPercentage = true
            }
            else {
              this.loadedPercentage = false
              this.isMinimumValue = false
            }
            if (this.downPaymentAmountModel && this.paymentPercentageModel && $event) {
              this.handleDPAmountUpdate($event)
            }
        }
      },
      isMinModelValue(model, minValue = 0) {
        let value = this.convertStringToNumber(model)
        if (value > minValue) return true
        else return false
      },
      validateNumber(event) {
        let keyCode = event.keyCode
        if (keyCode < 48 || keyCode > 57) {
          event.preventDefault()
        }
      },
      validateNumberMobile(event) {
        event.target.value = event.target.value.replace(/[^\d]/g, "")
        return false
      },
      HandleDPPercentUpdate(event) {
        if (this.homePriceModel && this.paymentPercentageModel && event.isTrusted) {
          this.downPaymentAmountModel = this.convertStringToNumber(this.homePriceModel) * this.convertStringToNumber(this.paymentPercentageModel) / 100
        }
      },
      handleDPAmountUpdate(event) {
        this.minimumRule('downPaymentAmountModel')
        if (this.homePriceModel && this.downPaymentAmountModel && this.downPaymentMax) {
          const percentage = this.convertStringToNumber(this.downPaymentAmountModel) / this.convertStringToNumber(this.homePriceModel) * 100
          this.paymentPercentageModel = (percentage % 1 !== 0 ? percentage.toFixed(2) : percentage) + "%"
        }
        if(!this.downPaymentMax || this.homePriceModel == this.downPaymentAmountModel) {
          this.paymentPercentageModel = "--"
        }
      },
      // Handle all calculations given the values inputted.
      async calculate() {
        // validations
        this.minimumRule('homePriceModel');
        this.minimumRule('downPaymentAmountModel');
        this.minimumRule('interestRateModel');
        this.minimumRule('termModel');
        this.initialDownPaymentState = false;
        this.initialHomePriceState = false;

        if (this.isDisabled) {
          return;
        }

        this.loading = true
        this.formSended = true
        this.termLength = this.termModel.text
        if (typeof this.termModel.text === "undefined") {
          this.termLength = this.termModel
        }
        let amount = this.convertStringToNumber()
        if (Boolean(amount) && amount > 0 && this.termModel && this.termModel !== "default") {
          //  try {
          //    window
          //      .HERO_analytics_rate_calculator
          //      .trackCalculateEvent(this.formInitial ? "Calculate" : "Re-calculate", this.zipcodeModel, this.convertStringToNumber, this.termLength)
          //  } catch (e) {}
          setTimeout(() => {
            this.loadMortgageRate()
            this.loading = false
          }, 2000)
        } else {
          this.errored = true
          this.formSended = true
          this.loading = false
        }
      },
      calculatePayment() {
        const monthlyRate = this.rate / 100 / 12;
        const numerator = monthlyRate * Math.pow(1 + monthlyRate, this.months);
        const denominator = Math.pow(1 + monthlyRate, this.months) - 1;
        const payment = this.principal * (numerator / denominator);
        return payment;
      },
      loadMortgageRate() {
        this.errored = false
        this.formInitial = false
        this.recalculate = false
        let amount = this.convertStringToNumber()
        this.principal = amount - this.convertStringToNumber(this.downPaymentAmountModel)
        this.rate = this.convertStringToPercentage(this.interestRateModel)
        this.months = this.termModel * 12;
        this.monthlyPayment = this.calculatePayment()
      },
      toggleLabel(event, type) {
        if (event.type === "focus") {
          // For IE support, keep the following add() methods separate
          event.target.parentElement.classList.add("has-focus")
          event.target.parentElement.classList.add("is-floating")
        }
        if (event.type === "blur") {
          if (type === 'downPayment') {
            // prevents displaying validation meesage on the page load
            this.initialDownPaymentState = false;
            this.initialHomePriceState = false;
          }
          else if (type === 'homePrice') {
            this.initialHomePriceState = false;
          }

          event.target.parentElement.classList.remove("has-focus")
          if (event.target.value === "") {
            event.target.parentElement.classList.remove("is-floating")
          }
        }
      },
      submitForm() {
        this.formSubmitted = true;
        this.calculate();
      }
    },
    props: {
      disclaimer: String
    },
    watch: {}
  }
</script>
